import { store } from "@/data/store";
function CustomLoadingScreen() {}

CustomLoadingScreen.prototype.displayLoadingUI = function() {
  store.commit("updateLoaderIsShowing", true);
};

CustomLoadingScreen.prototype.hideLoadingUI = function() {
  store.commit("updateLoaderIsShowing", false);
};

export default CustomLoadingScreen;
